import LoginFormPresenter from "./LoginFormPresenter";

const LoginForm = LoginFormPresenter

export default LoginForm